import { render, staticRenderFns } from "./notice_page.vue?vue&type=template&id=403c6ca6&scoped=true"
import script from "./notice_page.vue?vue&type=script&lang=js"
export * from "./notice_page.vue?vue&type=script&lang=js"
import style0 from "./notice_page.vue?vue&type=style&index=0&id=403c6ca6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403c6ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403c6ca6')) {
      api.createRecord('403c6ca6', component.options)
    } else {
      api.reload('403c6ca6', component.options)
    }
    module.hot.accept("./notice_page.vue?vue&type=template&id=403c6ca6&scoped=true", function () {
      api.rerender('403c6ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/notice_page.vue"
export default component.exports